import React from 'react';

export default function ScheduleBottom() {
  return (
    <>
      <ul className="schedule_label_list02">
        {[
          { text: '생', title: '생방송' },
          { text: '본', title: '본방송' },
          { text: 'All', title: '전체 시청' },
          { text: 'M', title: '수도권 방송' },
          { text: '수', title: '한국수어' },
          { text: '7', title: '7세 이상' },
          { text: '재', title: '재방송' },
          { text: '보라', title: '보는라디오', className: 'f_color01' },
          { text: '12', title: '12세 이상' },
          { text: '자', title: '자막방송' },
          { text: '해', title: '해설방송' },
          { text: '15', title: '15세 이상' },
          { text: '교', title: '교체편성' },
          { text: 'NO-ON', title: '온에어 불가' },
          { text: '19+', title: '19세 이상', className: 'f_color02' },
        ].map(({ text, title, className }, index) => (
          <li key={index}>
            <div className={`schedule_label_cont ${className || ''}`}>
              <span className="schedule_label">
                <span className="text">{text}</span>
              </span>
              <strong className="title">{title}</strong>
            </div>
          </li>
        ))}
      </ul>
      <ul className="schedule_info_dott">
        <li>본 편성표는 방송사 사정에 따라 변경될 수 있습니다.</li>
        <li>TV 다시보기 동영상은 방송 종료 후 업데이트됩니다.</li>
        <li>
          프로그램별/서비스별로 과금이 상이하므로 결제 전 과금 정보를 반드시
          확인하세요.
        </li>
      </ul>
    </>
  );
}
